import { Badge, Button, Rate, Result, Skeleton, Tag, Tooltip } from "antd";
import { CourseType, LessonType } from "App.types";
import React, { FC, useCallback, useState } from "react";
import { Levels, STATIC_URL } from "App.constants";
import { useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";
import cx from "classnames";
import styles from "./LessonsItem.module.scss";
import { CheckOutlined, CrownTwoTone, HeartOutlined, LoadingOutlined } from "@ant-design/icons";
import { encodeS3URI } from "App.helpers";
import API from "Api";

const LessonsItem: FC<{ course: CourseType; isLocked?: boolean; isCompleted?: boolean; lesson: LessonType; stars?: number }> = ({
  isCompleted,
  isLocked,
  stars,
  course: { level = 0 },
  lesson: { isActive, id, description, type: lessonType, story, grammar, title, status },
}) => {
  const [showWaiting, setShowWaiting] = useState(false);
  const navigate = useNavigate();

  const { picture, type, wordCount, translate, description: storyDescription, title: storyTitle } = story ?? {};

  const isLessonInProgress = status !== "ready";

  const sendToGenerate = useCallback(() => {
    API.ai.getLesson(id).then((data) => {
      if (data) {
      } else {
        setShowWaiting(true);
      }
    });
  }, [id]);

  return (
    <Badge.Ribbon
      rootClassName={cx(styles.lessonCard, {
        [styles.lessonCard__locked]: isLocked,
        [styles.mobile]: isMobile,
        [styles.lessonCard__completed]: isCompleted,
      })}
      className={cx({ [styles.hidden]: !Levels[level]?.title })}
      style={{ fontSize: isMobile ? 12 : undefined }}
      text={Levels[level]?.title}
      color={Levels[level]?.color}
    >
      <div
        id={`${id}`}
        className={styles.lessonCard__container}
        // style={{ backgroundImage: `url(${STATIC_URL}/lessons/${story.title?.toLowerCase()}.svg)` }}
        // style={{ backgroundImage: `url(${STATIC_URL}/stories/${story.title}/images/cover.svg)` }}
        onClick={() =>
          isLessonInProgress
            ? sendToGenerate()
            : navigate(`lessons/${lessonType || type}/${id}`, { state: { scrollPosition: window.scrollY } })
        }
      >
        <div className={cx(styles.content, { [styles.content__mobile]: isMobile })}>
          {picture ? (
            <img
              className={cx(styles.cover, { [styles.cover__jpg]: picture?.includes("jpg") })}
              alt={""}
              src={`${STATIC_URL}/stories/${encodeS3URI(storyTitle)}/${picture}`}
            />
          ) : (
            <img className={cx(styles.cover)} alt={""} src={`${STATIC_URL}/covers/${type}.svg`} />
          )}

          <div className={styles.right}>
            {isCompleted ? (
              <CheckOutlined />
            ) : (
              !!wordCount && (
                <div className={styles.desc}>
                  <CrownTwoTone />
                  {` ${wordCount}`}
                  {!isActive && <Tag color={"red"}>inactive</Tag>}
                </div>
              )
            )}
            <div className={styles.title}>{lessonType === "grammar" ? grammar?.title : title}</div>
            {status === "generating" ? (
              <Skeleton active style={{ width: "80%" }} />
            ) : (
              !isMobile && <div className={styles.desc}>{storyDescription || description || translate}</div>
            )}

            {stars && (
              <Tooltip title={"Оценка выполнения задания"}>
                <Rate className={styles.stars} allowHalf disabled defaultValue={stars} character={<HeartOutlined />} />
              </Tooltip>
            )}
          </div>
        </div>
      </div>
      {isMobile && <div className={styles.desc}>{storyDescription || description || translate}</div>}
      {/*{!!story.wordCount && <Tag bordered={false}>кол-во слов: {story.wordCount}</Tag>}*/}
      {showWaiting && (
        <Result
          status="info"
          icon={<LoadingOutlined />}
          title="Урок отправлен на генерацию, скоро все будет готово!"
          extra={
            <>
              <Button>Вернуться</Button>
              <Button type="primary" key="console">
                Go Console
              </Button>
            </>
          }
        />
      )}
    </Badge.Ribbon>
  );
};

export default LessonsItem;
